import { render, staticRenderFns } from "./studentroster.vue?vue&type=template&id=dced87b2&scoped=true"
import script from "./studentroster.vue?vue&type=script&lang=js"
export * from "./studentroster.vue?vue&type=script&lang=js"
import style0 from "./studentroster.vue?vue&type=style&index=0&id=dced87b2&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dced87b2",
  null
  
)

export default component.exports